import { useCallback, useEffect, useState } from "react";

const useModal = (initialState = false) => {
  const [isOpen, setIsOpen] = useState(initialState);

  const toggleModal = useCallback(() => {
    setIsOpen((open) => !open);
  }, []);

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
  }, [isOpen]);

  return {
    isOpen,
    toggleModal,
  };
};

export { useModal };
